import { useNavigate } from 'react-router-dom'

import { Box, Button, Radio, Spinner, Text } from '@factorialco/deprecated-design-system'
import { CostCenterLegalEntitiesMissingResourceAssignmentsDocument } from 'generated/resources/graphql'
import { uniqBy } from 'lodash'

import Modal from 'modules/core/components/Modal'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

interface LegalEntityPhaseProps {
  loading?: boolean
  selectedLegalEntityId: string
  setSelectedLegalEntityId: (legalEntityId: string) => void
  onClose: () => void
  onSubmit: () => void
}

export const LegalEntityPhase = ({
  loading,
  selectedLegalEntityId,
  setSelectedLegalEntityId,
  onClose,
  onSubmit,
}: LegalEntityPhaseProps) => {
  const { data, loading: loadingCostCenters } = useQuery(
    CostCenterLegalEntitiesMissingResourceAssignmentsDocument,
    { fetchPolicy: 'no-cache' }
  )

  const navigate = useNavigate()
  const { navigation } = useNavigation()

  const options = uniqBy(
    data?.costCenters.undistributedLegalEntitiesConnection.nodes.map((legalEntity) => ({
      label: legalEntity.legalName,
      value: legalEntity.id.toString(),
    })),
    'value'
  )

  if (options.length === 0) {
    navigate(navigation.settings.finance.costCenters.people.fullPath())
  }

  return (
    <Modal
      illustration="table-file"
      title={i18n.t('finance.cost_center_people_list.create.modal.title')}
      description={i18n.t('finance.cost_center_people_list.create.modal.description_1')}
      onClose={onClose}
      onSubmit={onSubmit}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button disabled={loading || loadingCostCenters || !selectedLegalEntityId} submit>
            {i18n.t('common.next')}
          </Button>
        </>
      }
    >
      <Box paddingBottom="s24">
        <Text.Normal>
          {i18n.t('finance.cost_center_people_list.create.modal.description_2')}
        </Text.Normal>
      </Box>

      <Box paddingBottom="s8">
        <Text.Normal weight="medium" size="200" color="grey1000">
          {i18n.t('finance.cost_center_people_list.create.modal.select_one')}
        </Text.Normal>
      </Box>
      <Box maxHeight="s360" overflowY="auto">
        {loading || loadingCostCenters ? (
          <Box justifyContent="center" alignItems="center" padding="s16">
            <Spinner />
          </Box>
        ) : (
          <Box gap="s8">
            {options.map((option) => (
              <Radio
                key={option.value}
                name={`legal_entity`}
                option={{
                  label: option.label,
                  value: String(option.value),
                }}
                value={selectedLegalEntityId ?? ''}
                onChange={(value) => setSelectedLegalEntityId(value)}
              />
            ))}
          </Box>
        )}
      </Box>
    </Modal>
  )
}
